import React, { useState, useEffect, useRef } from 'react';
import { Mic, Square } from 'lucide-react';
import './App.css';
import MultiSelect from './Components/Multiselect'; 
import CountyMultiSelect from './Components/County_Multiselect';
import StateMultiSelect from './Components/State_Multiselect';
import TopArrowButton from './TopArrowButton';


function NewApp() {
    const [countySelection, setCountySelection] = useState(['San Francisco']);
    const [stateSelection, setStateSelection] = useState('CA');
    const [userInput, setUserInput] = useState('');
    const [geminiClassifierResults, setGeminiClassifierResults] = useState({});
    
    const [searchResults, setSearchResults] = useState([]);
    const [facilitiesSearchResults, setFacilitiesSearchResults] = useState([]);
    const [resourcesSearchResults, setResourcesSearchResults] = useState([]);
    
    const [isLoading, setIsLoading] = useState(false);

    const [countyOptionList, setCountyOptionList] = useState(['Alameda', 'Alpine', 'Amador', 'Butte', 'Calaveras', 'Colusa', 'Contra Costa', 'Del Norte', 'El Dorado', 'Fresno', 'Glenn', 'Humboldt', 'Imperial', 'Inyo', 'Kern', 'Kings', 'Lake', 'Lassen', 'Los Angeles', 'Madera', 'Marin', 'Mariposa', 'Mendocino', 'Merced', 'Mono', 'Monterey', 'Napa', 'Nevada', 'Orange', 'Placer', 'Plumas', 'Riverside', 'Sacramento', 'San Benito', 'San Bernardino', 'San Diego', 'San Francisco', 'San Joaquin', 'San Luis Obispo', 'San Mateo', 'Santa Barbara', 'Santa Clara', 'Santa Cruz', 'Shasta', 'Sierra', 'Siskiyou', 'Solano', 'Sonoma', 'Stanislaus', 'Sutter', 'Trinity', 'Tulare', 'Tuolumne', 'Ventura', 'Yolo', 'Yuba']);
    // const allCACounties = ['Alameda', 'Alpine', 'Amador', 'Butte', 'Calaveras', 'Colusa', 'Contra Costa', 'Del Norte', 'El Dorado', 'Fresno', 'Glenn', 'Humboldt', 'Imperial', 'Inyo', 'Kern', 'Kings', 'Lake', 'Lassen', 'Los Angeles', 'Madera', 'Marin', 'Mariposa', 'Mendocino', 'Merced', 'Mono', 'Monterey', 'Napa', 'Nevada', 'Orange', 'Placer', 'Plumas', 'Riverside', 'Sacramento', 'San Benito', 'San Bernardino', 'San Diego', 'San Francisco', 'San Joaquin', 'San Luis Obispo', 'San Mateo', 'Santa Barbara', 'Santa Clara', 'Santa Cruz', 'Shasta', 'Sierra', 'Siskiyou', 'Solano', 'Sonoma', 'Stanislaus', 'Sutter', 'Trinity', 'Tulare', 'Tuolumne', 'Ventura', 'Yolo', 'Yuba']



    const [selectedGeminiResults, setSelectedGeminiResults] = useState([]);
    // const [scrollToTags, setScrollToTags] = useState(false);
    const [showNoInputMessage, setShowNoInputMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [voiceMessage, setVoiceMessage] = useState('');
    const recognitionRef = useRef(null);
    const manualVoiceStopRef = useRef(false);
    const heardSpeechRef = useRef(false);

    const [showFacilities, setShowFacilities] = useState(true);
    const [showResources, setShowResources] = useState(true);

    const promptChips = React.useMemo(() => [
      { label: 'Myself', text: "I'm looking for help for myself." },
      { label: 'Child or teen', text: "I'm looking for help for a child or teenager." },
      { label: 'Parent support', text: "I'm a parent or caregiver looking for support." },
      { label: 'Telehealth', text: "Telehealth or online care would be helpful." },
      { label: 'Crisis support', text: "I need crisis support or urgent mental health help." },
    ], []);

    const costChips = React.useMemo(() => [
      { label: 'Medi-Cal', text: "I need services that accept Medi-Cal or Medicaid." },
      { label: 'Medicare', text: "I need services that accept Medicare." },
      { label: 'Private', text: "I need services that accept private insurance." },
      { label: 'Low cost', text: "I need free, low-cost, sliding-scale, or payment-assisted care." },
      { label: 'Self-pay', text: "I may need cash or self-payment options." },
    ], []);

    const speechSupported = typeof window !== 'undefined' && (
      'SpeechRecognition' in window || 'webkitSpeechRecognition' in window
    );

    


    const label_mapping = React.useMemo(() => ({
      "MENTAL HEALTH TREATMENT": {'critical': 0, 'facilities': ['Mental health treatment'], 'resources': []},
      "SUBSTANCE USE TREATMENT": {'critical': 0, 'facilities': ['Substance use treatment'], 'resources': []},
      "FOR CHILDREN OR TEENAGERS": {'critical': 0, 'facilities': ['Children/Adolescents'], 'resources': ['CHILDREN & TEENS','CRISIS SUPPORT - TEENS','TEEN CRISIS SUPPORT']},
      "FOR YOUNG ADULTS": {'critical': 0, 'facilities': ['Young Adults'], 'resources': []},
      "FOR ADULTS": {'critical': 0, 'facilities': ['Adults'], 'resources': []},
      "FOR SENIORS OR ELDERLY": {'critical': 0, 'facilities': ['Seniors'], 'resources': ['AGING POPULATIONS']},
      "FOR FEMALE": {'critical': 0, 'facilities': ['Female'], 'resources': []},
      "FOR MALE": {'critical': 0, 'facilities': ['Male'], 'resources': []},
      'FOR PARENTS OF CHILDREN & TEENAGERS': {'critical': 0, 'facilities': [], 'resources': ['PARENTS OF CHILDREN & TEENS']},
      'AFRICAN AMERICAN COMMUNITY': {'critical': 0, 'facilities': [], 'resources': ['AFRICAN AMERICAN COMMUNITY']},
      'ASIAN AMERICAN COMMUNITY': {'critical': 0, 'facilities': [], 'resources': ['ASIAN AMERICAN COMMUNITY']},
      'LATINX COMMUNITY': {'critical': 0, 'facilities': [], 'resources': ['LATINX COMMUNITY']},
      'MUSLIM AMERICAN COMMUNITY': {'critical': 0, 'facilities': [], 'resources': ['MUSLIM AMERICAN COMMUNITY']},
      'NATIVE AMERICAN/INDIGENOUS COMMUNITY': {'critical': 0, 'facilities': [], 'resources': ['NATIVE AMERICAN/INDIGENOUS COMMUNITY']}, 
      "24-HOUR HOSPITAL INPATIENT CARE": {'critical': 0, 'facilities': ['Hospital inpatient/24-hour hospital inpatient'], 'resources': []},
      "OUTPATIENT CARE":{'critical': 0, 'facilities': ['Outpatient'], 'resources': []},
      "RESIDENTIAL/24-HOUR RESIDENTIAL CARE":{'critical': 0, 'facilities': ['Residential/24-hour residential'], 'resources': []},
      "TRANSITIONAL HOUSING/HALFWAY HOUSE/SOBER HOME": {'critical': 0, 'facilities': ['Transitional housing, halfway house, or sober home'], 'resources': []},
      "INDIVIDUAL PSYCHOTHERAPY OR COUNSELING": {'critical': 0, 'facilities': ['Individual counseling'], 'resources': ['PSYCHIATRISTS','PSYCHOTHERAPY/TALK THERAPY','PSYCHOLOGISTS','ONLINE MENTAL HEALTH SCREENING']},
      'ONLINE AND TELEMENTAL HEALTH':{'critical': 0, 'facilities': ['Telemedicine/telehealth therapy'], 'resources': ['ONLINE MENTAL HEALTH SCREENING','ONLINE AND TELEMENTAL HEALTH','ONLINE & TELECONFERENCE SUPPORT']},
      'CRISIS SUPPORT':{'critical': 0, 'facilities': [], 'resources': ['CRISIS/EMERGENCY MENTAL HEALTH SERVICES','PREPARING FOR A CRISIS','SUICIDAL IDEATION CRISIS','URGENT MEDICATION NEEDS']},
      'SUICIDAL IDEATION CRISIS':{'critical': 0, 'facilities': ['Suicide prevention services'], 'resources': ['SUICIDE','SUPPORT GROUPS FOR SUICIDAL IDEATION & LOSS FROM SUICIDE','SUPPORTING SOMEONE WITH SUICIDAL THOUGHTS','CRISIS/EMERGENCY MENTAL HEALTH SERVICES','SUICIDAL IDEATION CRISIS']},
      'LOSS FROM SUICIDE':{'critical': 0, 'facilities': [], 'resources': ['LOSS FROM SUICIDE','SUPPORT GROUPS FOR SUICIDAL IDEATION & LOSS FROM SUICIDE','GRIEF SUPPORT','GRIEF SUPPORT FOR CHILDREN & TEENS']},
      'PEER SUPPORT SERVICES': {'critical': 0, 'facilities': ['Mentoring/peer support'], 'resources': ['PEER SUPPORT SERVICES']},
      'FRIENDSHIP SUPPORT':{'critical': 0, 'facilities': [], 'resources': ['FRIENDSHIP SUPPORT']},
      "GROUP COUNSELING":{'critical': 0, 'facilities': ['Group counseling'], 'resources': []},
      'FAMILY RELATIONSHIP SUPPORT':{'critical': 0, 'facilities': ['Couples/family therapy'], 'resources': ['RELATIONSHIPS','FAMILY RELATIONSHIP SUPPORT']},
      "MARITAL/COUPLES COUNSELING":{'critical': 0, 'facilities': ['Marital/couples counseling'], 'resources': ['RELATIONSHIPS','FAMILY RELATIONSHIP SUPPORT', 'ROMANTIC', 'ROMANTIC RELATIONSHIP HELP']},
      'EMPLOYMENT':{'critical': 0, 'facilities': ['Employment counseling or training'], 'resources': ['EMPLOYMENT','FINDING A JOB','WORKPLACE MENTAL HEALTH','RESILIENCE-BUILDING']},
      'GRIEF SUPPORT':{'critical': 1, 'facilities': [], 'resources': ['GRIEF SUPPORT','GRIEF SUPPORT FOR CHILDREN & TEENS','EMOTIONAL SUPPORT']},
      "SUICIDE PREVENTION":{'critical': 0, 'facilities': [], 'resources': []},
      'GUN VIOLENCE PREVENTION':{'critical': 0, 'facilities': [], 'resources': ['GUN VIOLENCE PREVENTION']},
      "CASE MANAGEMENT SERVICES":{'critical': 0, 'facilities': ['Case management service'], 'resources': []},
      "HOUSING SERVICES":{'critical': 1, 'facilities': ['Housing services'], 'resources': ['HOUSING','HOUSING DISCRIMINATION & COMPLAINTS','HOUSING EVICTION']},
      "EDUCATION SERVICES":{'critical': 0, 'facilities': ['Education services'], 'resources': []},
      'END-OF-LIFE TRANSITION':{'critical': 0, 'facilities': [], 'resources': ['END-OF-LIFE TRANSITION','LONG-TERM CARE PLANNING']},
      "TRANSPORTATION ASSISTANCE":{'critical': 0, 'facilities': ['Transportation assistance'], 'resources': ['TRANSPORTATION','TRANSPORTATION FOR ELDERLY']},
      "DIALECTICAL BEHAVIOR THERAPY":{'critical': 0, 'facilities': ['Dialectical behavior therapy'], 'resources': []},
      "COGNITIVE BEHAVIORAL THERAPY":{'critical': 0, 'facilities': ['Cognitive behavioral therapy'], 'resources': []},
      "ANGER MANAGEMENT SERVICES":{'critical': 0, 'facilities': ['Anger management'], 'resources': []},
      "THERAPEUTIC FOSTER CARE SERVICES":{'critical': 0, 'facilities': [], 'resources': []},
      "ELECTROCONVULSIVE THERAPY":{'critical': 0, 'facilities': [], 'resources': []},
      "EYE MOVEMENT DESENSITIZATION AND REPROCESSING THERAPY":{'critical': 0, 'facilities': [], 'resources': []},
      "COGNITIVE REMEDIATION THERAPY":{'critical': 0, 'facilities': [], 'resources': []},
      "KETAMINE INFUSION THERAPY":{'critical': 0, 'facilities': [], 'resources': []},
      "TRANSCRANIAL MAGNETIC STIMULATION THERAPY":{'critical': 0, 'facilities': [], 'resources': []},
      "DRUG OR ALCOHOL URINE SCREENING":{'critical': 0, 'facilities': ['Drug or alcohol urine screening'], 'resources': []},
      "NICOTINE REPLACEMENT THERAPY":{'critical': 0, 'facilities': ['Nicotine replacement'], 'resources': []},
      "SMOKING/VAPING/TOBACCO CESSATION COUNSELING SERVICE":{'critical': 0, 'facilities': ['Smoking/vaping/tobacco cessation counseling'], 'resources': []},
      "DETOXIFICATION SERVICES":{'critical': 0, 'facilities': ['Detoxification'], 'resources': []},
      "TUBERCULOSIS SCREENING":{'critical': 0, 'facilities': ['TB screening'], 'resources': []},
      "STD TESTING":{'critical': 0, 'facilities': ['STD testing'], 'resources': []},
      "METABOLIC SYNDROME MONITORING":{'critical': 0, 'facilities': ['Metabolic syndrome monitoring'], 'resources': []},
      "HEPATITIS B (HBV) TESTING":{'critical': 0, 'facilities': ['Testing for Hepatitis B (HBV)'], 'resources': []},
      "HEPATITIS C (HCV) TESTING":{'critical': 0, 'facilities': ['Testing for Hepatitis C (HCV)'], 'resources': []},
      "TOBACCO SCREENING":{'critical': 0, 'facilities': ['Smoking/vaping/tobacco cessation counseling'], 'resources': []},
      'ANIMALS (EMOTIONAL SUPPORT & SERVICE DOGS)':{'critical': 0, 'facilities': [], 'resources': ['ANIMALS (EMOTIONAL SUPPORT & SERVICE DOGS)']},
      'MENTAL HEALTH POLICY/SELF-ADVOCACY':{'critical': 0, 'facilities': [], 'resources': ['MENTAL HEALTH POLICY/SELF-ADVOCACY','PATIENT ADVOCATE SERVICES']},
      'PATIENT ADVOCATE SERVICES':{'critical': 0, 'facilities': [], 'resources': ['MENTAL HEALTH POLICY/SELF-ADVOCACY','PATIENT ADVOCATE SERVICES']},
      "LGBTQ": {'critical': 1, 'facilities': ['Lesbian, gay, bisexual, transgender, or queer/questioning (LGBTQ)'], 'resources': ['LGBTQI COMMUNITY']},
      'TRANSGENDER': {'critical': 1, 'facilities': ['Lesbian, gay, bisexual, transgender, or queer/questioning (LGBTQ)'], 'resources': ['LGBTQI COMMUNITY','TRANSGENDER RESOURCES']},
      "VETERANS": {'critical': 1, 'facilities': ['Veterans'], 'resources': ['VETERAN CRISIS SUPPORT','VETERANS/MILITARY']},
      "ACTIVE DUTY MILITARY": {'critical': 1, 'facilities': ['Active duty military'], 'resources': ['VETERANS/MILITARY']},
      "MILITARY FAMILIES": {'critical': 1, 'facilities': ['Members of military families'], 'resources': ['VETERANS/MILITARY']},
      "PREGNANT/POSTPARTUM WOMEN": {'critical': 1, 'facilities': ['Pregnant/postpartum women'], 'resources': []},
      'DISABILITY RESOURCES': {'critical': 1, 'facilities': [], 'resources': ['DISABILITY BENEFITS (INCLUDING SSI & SSDI)','DISABILITY RIGHTS','DISABILITY EDUCATION','DISABILITY EMPLOYMENT/ACCOMMODATIONS','DISABILITY HOUSING DISCRIMINATION/COMPLAINTS','PHYSICAL DISABILITY','INTELLECTUAL DISABILITIES']},
      'INCARCERATED PERSONS': {'critical': 1, 'facilities': ['Criminal justice (other than DUI/DWI)/Forensic clients'], 'resources': ['INCARCERATED PERSONS','APPEALING SENTENCE FOR INCARCERATED PERSONS','MISTREATMENT WHILE INCARCERATED','REENTRY AFTER A PERIOD OF INCARCERATION']},
      'LAW ENFORCEMENT COMMUNITY': {'critical': 1, 'facilities': [], 'resources': ['LAW ENFORCEMENT COMMUNITY']},
      'HEALTHCARE & FRONTLINE WORKERS': {'critical': 1, 'facilities': [], 'resources': ['HEALTHCARE & FRONTLINE WORKERS']},
      "HIV OR AIDS": {'critical': 1, 'facilities': ['Clients with HIV or AIDS','HIV testing'], 'resources': []},
      "TRAUMA": {'critical': 1, 'facilities': ['Clients who have experienced trauma'], 'resources': ['TRAUMA']},
      'DEPRESSION': {'critical': 1, 'facilities': [], 'resources': ['DEPRESSION']},
      "ALZHEIMER'S OR DEMENTIA": {'critical': 1, 'facilities': ["Persons with Alzheimer's or dementia"], 'resources': ['ALZHEIMER’S/DEMENTIA']},
      "EATING DISORDERS": {'critical': 1, 'facilities': ['Persons with eating disorders'], 'resources': ['EATING DISORDERS']},
      'ANOSOGNOSIA': {'critical': 1, 'facilities': [], 'resources': ['ANOSOGNOSIA']},
      'ANXIETY DISORDERS': {'critical': 1, 'facilities': [], 'resources': ['ANXIETY DISORDERS']},
      'AUTISM SPECTRUM DISORDER (ASD)': {'critical': 1, 'facilities': [], 'resources': ['AUTISM SPECTRUM DISORDER (ASD)']},
      'BIPOLAR DISORDER (BD)': {'critical': 1, 'facilities': [], 'resources': ['BIPOLAR DISORDER (BD)']},
      'BRAIN INJURY': {'critical': 1, 'facilities': ['Persons with traumatic brain injury (TBI)'], 'resources': ['BRAIN INJURY']},
      'DISSOCIATIVE DISORDERS': {'critical': 1, 'facilities': [], 'resources': ['DISSOCIATIVE DISORDERS']},
      'PERSONALITY DISORDERS': {'critical': 1, 'facilities': [], 'resources': ['PERSONALITY DISORDERS','BORDERLINE PERSONALITY DISORDER','NARCISSISTIC PERSONALITY DISORDER']},
      'POST-TRAUMATIC STRESS DISORDER (PTSD)': {'critical': 1, 'facilities': ['Persons with post-traumatic stress disorder (PTSD)'], 'resources': ['POST-TRAUMATIC STRESS DISORDER (PTSD)','TRAUMA']},
      'PSYCHOSIS': {'critical': 1, 'facilities': ['Persons experiencing first-episode psychosis'], 'resources': ['FIRST EPISODE PSYCHOSIS (FEP)','PSYCHOSIS']},
      "CHILDREN/ADOLESCENTS WITH SERIOUS EMOTIONAL DISTURBANCE (SED)": {'critical': 1, 'facilities': ['Children/adolescents with serious emotional disturbance (SED)'], 'resources': []},
      'OBSESSIVE-COMPULSIVE DISORDER (OCD)': {'critical': 1, 'facilities': [], 'resources': ['OBSESSIVE-COMPULSIVE DISORDER (OCD)']},
      'OPPOSITIONAL DEFIANT DISORDER (ODD)': {'critical': 1, 'facilities': [], 'resources': ['OPPOSITIONAL DEFIANT DISORDER (ODD)']},
      'SELF-INJURY': {'critical': 1, 'facilities': [], 'resources': ['SELF-INJURY']},
      'SLEEP DISORDERS': {'critical': 1, 'facilities': [], 'resources': ['SLEEP DISORDERS']},
      'SCHIZOPHRENIA': {'critical': 1, 'facilities': [], 'resources': ['SCHIZOPHRENIA SPECTRUM & OTHER PSYCHOTIC DISORDERS']},
      'SUBSTANCE USE DISORDERS': {'critical': 1, 'facilities': ['Substance use treatment'], 'resources': ['SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      'ALCOHOLISM': {'critical': 1, 'facilities': ['Substance use treatment'], 'resources': ['SUBSTANCE RELATED & ADDICTIVE DISORDERS','ALCOHOLISM']},
      'COMPULSIVE SEXUAL BEHAVIOR': {'critical': 1, 'facilities': [], 'resources': ['COMPULSIVE SEXUAL BEHAVIOR','SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      'GAMBLING ADDICTION': {'critical': 1, 'facilities': ['Treatment for gambling disorder'], 'resources': ['GAMBLING ADDICTION','SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      'INTERNET & GAMING ADDICTION': {'critical': 1, 'facilities': [], 'resources': ['INTERNET & GAMING ADDICTION','SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      'NARCOTICS ADDICTION': {'critical': 1, 'facilities': ['Substance use disorder counseling'], 'resources': ['NARCOTICS ADDICTION','SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      "DOMESTIC VIOLENCE": {'critical': 1, 'facilities': ['Domestic violence services, including family or partner'], 'resources': ['ABUSE','DOMESTIC VIOLENCE & SEXUAL ASSAULT']},
      "SEXUAL ABUSE": {'critical': 1, 'facilities': ['Clients who have experienced sexual abuse'], 'resources': ['ABUSE','DOMESTIC VIOLENCE & SEXUAL ASSAULT']},
      'HOARDING': {'critical': 1, 'facilities': [], 'resources': ['HOARDING','SUBSTANCE RELATED & ADDICTIVE DISORDERS']},
      'CHILD ABUSE':{'critical': 1, 'facilities': [], 'resources': ['ABUSE','CHILD ABUSE']},
      'ELDER ABUSE':{'critical': 1, 'facilities': [], 'resources': ['ABUSE','ELDER ABUSE']},
      'ONLINE ABUSE':{'critical': 1, 'facilities': [], 'resources': ['ABUSE','ONLINE ABUSE']},
      "REPRODUCTIVE HEALTH":{'critical': 1, 'facilities': [], 'resources': ["REPRODUCTIVE HEALTH RELATED - MENTAL HEALTH"]},
      'MISSING PERSONS':{'critical': 1, 'facilities': [], 'resources': ['MISSING PERSONS']},
      'LONG COVID':{'critical': 1, 'facilities': [], 'resources': ['LONG COVID RESOURCES']},
      'ATTENTION DEFICIT/HYPERACTIVITY DISORDER (ADHD)':{'critical': 1, 'facilities': [], 'resources': ['ATTENTION DEFICIT/HYPERACTIVITY DISORDER (ADHD)']},
      "LEGAL ADVOCACY":{'critical': 0, 'facilities': ['Legal advocacy'], 'resources': ['LOW-COST/PRO BONO (FREE) LEGAL SERVICES']},
      'LOW-COST/PRO BONO (FREE) LEGAL SERVICES':{'critical': 1, 'facilities': [], 'resources': ['LOW-COST/PRO BONO (FREE) LEGAL SERVICES']},
      'LEGAL GUARDIANSHIP & CONSERVATORSHIP':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['LOW-COST/PRO BONO (FREE) LEGAL SERVICES','LEGAL GUARDIANSHIP & CONSERVATORSHIP']},
      'IMMIGRATED & UNDOCUMENTED PERSONS':{'critical': 1, 'facilities': [], 'resources': ['IMMIGRATED & UNDOCUMENTED PERSONS']},
      'COMPLAINTS AGAINST A CORRECTIONAL FACILITY':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['COMPLAINTS AGAINST A CORRECTIONAL FACILITY','LOW-COST/PRO BONO (FREE) LEGAL SERVICES']},
      'COMPLAINTS AGAINST A HOUSING FACILITY':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['COMPLAINTS AGAINST A HOUSING FACILITY','LOW-COST/PRO BONO (FREE) LEGAL SERVICES']},
      'COMPLAINTS AGAINST A TREATMENT FACILITY OR HOSPITAL':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['COMPLAINTS AGAINST A TREATMENT FACILITY OR HOSPITAL','LOW-COST/PRO BONO (FREE) LEGAL SERVICES']},
      'ACCOMMODATIONS & DISCRIMINATION ISSUES':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['ACCOMMODATIONS & DISCRIMINATION ISSUES']},
      'INVOLUNTARY & CIVIL COMMITMENT':{'critical': 1, 'facilities': ['Legal advocacy'], 'resources': ['INVOLUNTARY & CIVIL COMMITMENT']},
      "PAYMENT OR INSURANCE ASSISTANCE":{'critical': 0, 'facilities': ['Payment assistance (check with facility for details)'], 'resources': ['FINANCIAL ASSISTANCE','AFFORDABLE TREATMENT (NO INSURANCE OR PUBLIC INSURANCE)','INSURANCE COVERAGE & COMPLAINTS','MEDICAL CARE & HOSPITAL BILLS','FINANCIAL ASSISTANCE FOR PRESCRIPTION MEDICATION','HEALTH INSURANCE PORTABILITY & ACCOUNTABILITY ACT (HIPAA)','INSURANCE']},
      'PRIVATE INSURANCE ACCEPTED':{'critical': 1, 'facilities': ['Private health insurance'], 'resources': ['PRIVATE INSURANCE']},
      "MEDICARE INSURANCE ACCEPTED":{'critical': 1, 'facilities': ['Medicare'], 'resources': ['FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','INSURANCE']},
      "MEDICAID (OR MEDI-CAL) INSURANCE ACCEPTED":{'critical': 1, 'facilities': ['Medicaid'], 'resources': ['FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','INSURANCE']},
      "FEDERAL MILITARY INSURANCE (E.G., TRICARE) ACCEPTED":{'critical': 1, 'facilities': ['Federal military insurance (e.g., TRICARE)'], 'resources': ['FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','INSURANCE']},
      "CASH OR SELF-PAYMENT ACCEPTED":{'critical': 1, 'facilities': ['Cash or self-payment'], 'resources': ['FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','INSURANCE']},
      "U.S. DEPARTMENT OF VA FUNDS PAYMENT/INSURANCE ACCEPTED":{'critical': 1, 'facilities': ['U.S. Department of VA funds'], 'resources': ['FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','INSURANCE']},
      'AFFORDABLE TREATMENT (NO INSURANCE OR PUBLIC INSURANCE)':{'critical': 1, 'facilities': [], 'resources': ['AFFORDABLE TREATMENT (NO INSURANCE OR PUBLIC INSURANCE)','FINANCIAL ASSISTANCE','MEDICAL CARE & HOSPITAL BILLS','FINANCIAL ASSISTANCE FOR PRESCRIPTION MEDICATION','HEALTH INSURANCE PORTABILITY & ACCOUNTABILITY ACT (HIPAA)','INSURANCE','INSURANCE COVERAGE & COMPLAINTS']},
      'PRESCRIPTION MEDICATION FINANCIAL ASSISTANCE': {'critical': 1, 'facilities': [], 'resources': ['FINANCIAL ASSISTANCE','PRESCRIPTION MEDICATION FINANCIAL ASSISTANCE','MEDICATION']},
      "SIGN LANGUAGE SERVICES FOR DEAF AND HARD OF HEARING":{'critical': 1, 'facilities': ['Sign language services for the deaf and hard of hearing'], 'resources': []},
      "SPANISH LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['Spanish'], 'resources': []},
      "CHINESE LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['Any Chinese Language'], 'resources': []},
      "FRENCH LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['French'], 'resources': []},
      "ITALIAN LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['Italian'], 'resources': []},
      "GERMAN LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['German'], 'resources': []},
      "JAPANESE LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['Japanese'], 'resources': []},
      "KOREAN LANGUAGE TRANSLATION SERVICE":{'critical': 1, 'facilities': ['Korean'], 'resources': []},
      'RESEARCH/ACADEMIA FOR MENTAL HEALTH':{'critical': 1, 'facilities': [], 'resources': ['RESEARCH/ACADEMIA FOR MENTAL HEALTH']},
      'INTERNATIONAL MENTAL HEALTH RESOURCES':{'critical': 1, 'facilities': [], 'resources': ['INTERNATIONAL MENTAL HEALTH RESOURCES']}
      }), []);
      


    // Define options arrays
    const generalOptions = React.useMemo(() => Object.keys(label_mapping), [label_mapping]); // used to be values with the old label_mapping

    // always refresh by running the filter search api to get the services to display
    const hasGeminiTags =
        Array.isArray(geminiClassifierResults) && geminiClassifierResults.length > 0;

    useEffect(() => {
      if (countySelection.length > 0 && hasGeminiTags) {

          const allFacilities_tags = [];
          const allResources_tags = [];
          // const allCritical_tags = []
          selectedGeminiResults.forEach(label => {
              const entry = label_mapping[label];
              if (!entry) return;
              const facilities = entry.facilities;
              const resources = entry.resources;
              // const criticality = label_mapping[label]['critical']
              // Check if facilities and resources are arrays, then concatenate them
              if (Array.isArray(facilities)) {
                facilities.forEach(facility => {
                    if (!allFacilities_tags.includes(facility)) {
                        allFacilities_tags.push(facility);
                    }
                });
            }
        
            // Check if resources is an array and add unique elements to allResources_tags
            if (Array.isArray(resources)) {
                resources.forEach(resource => {
                    if (!allResources_tags.includes(resource)) {
                        allResources_tags.push(resource);
                    }
                });
            }

         


          });

      
          // const inputs = selectedGeminiResults;

          // const gemini_results = geminiClassifierResults.map((label) => label_mapping[label])
  
          const fetchData = async () => {
              setIsLoading(true);           
              try {
                  const response = await fetch('/filtersearch_gemini', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ userInput, selectedGeminiResults, allFacilities_tags, allResources_tags, stateSelection, countySelection })
                  });
  
                  if (response.ok) {
                      const data = await response.json();
                      const { facilities_results, resources_results } = data

                   
                      setSearchResults(facilities_results);
                      setFacilitiesSearchResults(facilities_results)
                      setResourcesSearchResults(resources_results)


                  } else {
                      throw new Error('Network response was not ok');
                  }
              } catch (error) {
                  console.error('Error:', error);
                  setErrorMessage('We could not refresh the results. Please try again.');
              }
              setIsLoading(false);
          };
  
          fetchData();
      }
  }, [countySelection, selectedGeminiResults, hasGeminiTags, label_mapping, stateSelection, userInput]);
  


    useEffect(() => {
        const anchor = document.getElementById('anchor');
        if (anchor && selectedGeminiResults.length > 0) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
    }, [searchResults, selectedGeminiResults.length]);
    

    const handleCountySelectionChange = (selectedCounties) => {
        setCountySelection(selectedCounties);
    };

    const handleStateSelectionChange = (selectedState) => {
      setStateSelection(selectedState);

      const getCounties = async () => {
        setIsLoading(true);           
        try {
            const response = await fetch('/getCountiesfromState', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ selectedState })
            });

            if (response.ok) {
                const data = await response.json();
                
                setCountyOptionList(data);
                
                handleCountySelectionChange([data[0]])

            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error:', error);
        }
        setIsLoading(false);
    };

    getCounties();


  };

   
    const handleUserInputChange = (event) => {
        setShowNoInputMessage(false);
        setErrorMessage('');
        setVoiceMessage('');
        setUserInput(event.target.value);
    };

    const appendToUserInput = (text, dedupe = true) => {
        setShowNoInputMessage(false);
        setErrorMessage('');
        setVoiceMessage('');
        setUserInput((current) => {
            if (dedupe && current.includes(text)) return current;
            const separator = current.trim().length > 0 ? '\n' : '';
            return `${current}${separator}${text}`;
        });
    };

    const handleVoiceInput = () => {
        if (!speechSupported) {
            setErrorMessage('Voice input is not supported in this browser.');
            return;
        }

        if (isListening && recognitionRef.current) {
            manualVoiceStopRef.current = true;
            recognitionRef.current.stop();
            return;
        }

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognition.lang = 'en-US';
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => {
            manualVoiceStopRef.current = false;
            heardSpeechRef.current = false;
            setIsListening(true);
            setErrorMessage('');
            setVoiceMessage('Listening. If nothing appears, check that your browser allowed microphone access.');
        };
        recognition.onresult = (event) => {
            let finalTranscript = '';
            for (let i = event.resultIndex; i < event.results.length; i += 1) {
                const transcript = event.results[i][0]?.transcript || '';
                if (event.results[i].isFinal) {
                    finalTranscript += transcript;
                }
            }
            finalTranscript = finalTranscript.trim();
            if (finalTranscript) {
                heardSpeechRef.current = true;
                appendToUserInput(finalTranscript, false);
                setVoiceMessage('Added voice text. Keep talking or press Stop.');
            }
        };
        recognition.onerror = (event) => {
            if (manualVoiceStopRef.current || event.error === 'aborted') return;
            if (event.error === 'no-speech') {
                setVoiceMessage('No speech was captured. Check microphone permission, then press Use voice and speak after the browser starts listening.');
                return;
            }
            if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
                setErrorMessage('Microphone access is blocked. Allow microphone permission for this site in your browser, then try Use voice again.');
                return;
            }
            if (event.error === 'audio-capture') {
                setErrorMessage('No microphone was found. Check your microphone and browser permission, or type instead.');
                return;
            }
            setVoiceMessage('Voice input stopped. Check microphone permission if nothing was added, or type instead.');
        };
        recognition.onend = () => {
            setIsListening(false);
            recognitionRef.current = null;
            if (manualVoiceStopRef.current) {
                setVoiceMessage(heardSpeechRef.current ? 'Voice text added.' : '');
                manualVoiceStopRef.current = false;
                return;
            }
            if (!heardSpeechRef.current) {
                setVoiceMessage('Voice input ended without capturing text. Check microphone permission if nothing appeared, then try again.');
            }
        };

        recognitionRef.current = recognition;
        try {
            recognition.start();
        } catch (error) {
            console.error('Voice input failed to start:', error);
            setIsListening(false);
            recognitionRef.current = null;
            setVoiceMessage('Voice input could not start. Check microphone permission for this site, or type instead.');
        }
    };

   

    const handleGeminiChange = (selectedOptions) => {
        if (typeof selectedOptions === 'string') {
            selectedOptions = [selectedOptions];
        }
        setSelectedGeminiResults(selectedOptions);
        
    }

    // when the user clicks, run the gemini api request 
    const handleSearchClick = async () => {
      if ((userInput.trim().length > 0) && (!(countySelection.length === 0))) {
        setIsLoading(true);
        setErrorMessage('');

        try {
          const geminiresponse = await fetch('/run_gemini', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({ userInput })
          });

          const payload = await geminiresponse.json().catch(() => ({}));

          if (geminiresponse.ok) {
              const geminiData = payload;

              // saving an original copy of the gemini results
              setGeminiClassifierResults(geminiData);

              // save the data as the label mapping result
              handleGeminiChange(geminiData);
          } else {
              console.error('run_gemini failed:', geminiresponse.status, payload);
              setErrorMessage(payload.error || 'We could not match your description right now. Please try again.');
          }
      } catch (error) {
          console.error('Error:', error);
          setErrorMessage('We could not connect to the matching service. Please try again.');
      }
      setIsLoading(false);
      } else {
        setShowNoInputMessage(true)
        setErrorMessage('');

      }
      
  };


    function FacilitiesSearchResult({ results }) {
        const colorMap = {
            'Type of Care': '#005B9A', // Dark Blue
            'Service Setting (e.g., Outpatient, Residential, Inpatient, etc.)': '#ee7d72', // Reddish Orange
            'Treatment Approaches': '#65a4cf', // Light Blue
            // 'Payment/Insurance/Funding Accepted': 'darkgrey',// '#b48696', // purplish
            'Other': '#e4b24a' // Yellowish
        };

        const formatFacilityForEmail = (facility) => {
          let emailBody = `${facility.full_name}\n`;
          emailBody += `${facility.street1}, ${facility.city} ${facility.state} ${facility.zip}, ${facility.county} County\n`;
          emailBody += `${facility.website === 'http://' ? 'No website available' : facility.website} | ${facility.phone}\n\n`;
  
          Object.keys(colorMap).forEach(categoryKey => {
              if (facility.tags_of_interest[categoryKey]) {
                  emailBody += `${categoryKey}:\n`;
                  facility.tags_of_interest[categoryKey].forEach((item) => {
                      emailBody += `- ${item}\n`;
                  });
                  emailBody += '\n';
              }
          });
  
          return encodeURIComponent(emailBody);
      };

        const resultTagsFor = (facility, categoryKey) =>
          Array.isArray(facility.tags_of_interest?.[categoryKey])
            ? facility.tags_of_interest[categoryKey]
            : [];

        const formatAddress = (facility) => {
          const street2 = facility.street2 && facility.street2 !== 0 ? `, ${facility.street2}` : '';
          return `${facility.street1 || ''}${street2}, ${facility.city || ''} ${facility.state || ''} ${facility.zip || ''}, ${facility.county || ''} County`;
        };

        const summarizeTag = (tag) => {
          const lower = tag.toLowerCase();
          if (lower.includes('medicaid')) return 'accepts Medicaid or Medi-Cal';
          if (lower.includes('medicare')) return 'accepts Medicare';
          if (lower.includes('private health insurance')) return 'accepts private insurance';
          if (lower.includes('payment assistance') || lower.includes('sliding fee')) return 'may offer payment assistance';
          if (lower.includes('telemedicine') || lower.includes('telehealth')) return 'offers telehealth';
          if (lower.includes('children') || lower.includes('adolescents')) return 'serves children or teens';
          if (lower.includes('outpatient')) return 'offers outpatient care';
          if (lower.includes('residential')) return 'offers residential care';
          if (lower.includes('inpatient')) return 'offers inpatient care';
          if (lower.includes('suicide')) return 'lists suicide prevention support';
          if (lower.includes('trauma')) return 'matches trauma-related needs';
          if (lower.includes('counseling') || lower.includes('therapy')) return `offers ${tag.toLowerCase()}`;
          return tag.charAt(0).toLowerCase() + tag.slice(1);
        };

        const matchReasonsFor = (facility) => {
          const orderedTags = [
            ...resultTagsFor(facility, 'Type of Care'),
            ...resultTagsFor(facility, 'Service Setting (e.g., Outpatient, Residential, Inpatient, etc.)'),
            ...resultTagsFor(facility, 'Treatment Approaches'),
            ...resultTagsFor(facility, 'Other'),
          ];
          return [...new Set(orderedTags.map(summarizeTag))].slice(0, 4);
        };

        const callQuestions = [
          'Are you accepting new patients?',
          'Do you take my insurance or offer low-cost options?',
          'Do you offer the matched services listed here?',
          'Is telehealth available?',
        ];
  

        return (
          <div className="SearchResult">
            
            {results.map((facility, index) => (
              <div className='facility-card' key={index}>
                <div className='internal-facility-card'>
                  <div className="card-topline">
                    <span className="result-type">Local facility</span>
                    {facility.county && <span className="source-note">SAMHSA data</span>}
                  </div>
                  <div className='title'><strong>{facility.full_name}</strong></div>
                  <p className='address'>{formatAddress(facility)}</p>

                  <div className="action-row">
                    {facility.phone && (
                      <a className="action-button primary-action" href={`tel:${facility.phone}`}>
                        Call {facility.phone}
                      </a>
                    )}
                    {facility.website !== "http://" && facility.website && (
                      <a className="action-button" href={facility.website} target="_blank" rel="noopener noreferrer">
                        Website
                      </a>
                    )}
                    <a className="action-button" href={`mailto:?subject=Search Result for ${facility.full_name}&body=${formatFacilityForEmail(facility)}`} target="_blank" rel="noopener noreferrer">
                      Email
                    </a>
                  </div>

                  {resultTagsFor(facility, 'Type of Care').length > 0 && (
                    <div className="match-summary">
                      <span className="match-label">Matched care</span>
                      <span>{resultTagsFor(facility, 'Type of Care').slice(0, 3).join(', ')}</span>
                    </div>
                  )}

                  {matchReasonsFor(facility).length > 0 && (
                    <div className="why-match">
                      <div className="why-title">Why this matched</div>
                      <ul>
                        {matchReasonsFor(facility).map((reason) => (
                          <li key={reason}>{reason}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="call-checklist">
                    <div className="why-title">Ask when you call</div>
                    <ul>
                      {callQuestions.map((question) => (
                        <li key={question}>{question}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Rendering items_by_category */}
                  <div className='TagsOfInterestBox'>
                    {Object.keys(colorMap).map((categoryKey, catIndex) => (
                      <React.Fragment key={catIndex}> 
                        {resultTagsFor(facility, categoryKey).map((item, itemIndex) => (
                          <div key={itemIndex} style={{ backgroundColor: colorMap[categoryKey] }} className='TagOfInterest'>{item}</div>
                        ))}
                      </React.Fragment>
                    ))}
                  </div>
                  <p className="confirm-note">Confirm availability, insurance, and intake details before visiting.</p>
                </div>
            </div>

            ))}
            
          </div>
        );
      }

      function ResourcesSearchResult({ results }) {
        const colorMap = {
            'Main Categories': '#ee7d72', // salmon pink
            'Extra Categories': '#e4b24a'//   Yellowish
            //  '#65a4cf' Light Blue
           
        };

        const formatResourcesForEmail = (facility) => {
          const websites = Array.isArray(facility.website) ? facility.website : [];
          let emailBody = `${facility.full_name}\n`;
          emailBody += `${websites.join(', ')}\n\n`;
         
          emailBody += `${facility.desc}\n\n`;
      
          Object.keys(colorMap).forEach(categoryKey => {
            if (facility.tags_of_interest[categoryKey]) {
              emailBody += `${categoryKey}:\n`;
              facility.tags_of_interest[categoryKey].forEach((item) => {
                emailBody += `- ${item}\n`;
              });
              emailBody += '\n';
            }
          });
  
          return encodeURIComponent(emailBody);
      };

        const resourceTagsFor = (facility, categoryKey) =>
          Array.isArray(facility.tags_of_interest?.[categoryKey])
            ? facility.tags_of_interest[categoryKey]
            : [];

        const resourceReasonsFor = (facility) => {
          const categories = [
            ...resourceTagsFor(facility, 'Main Categories'),
            ...resourceTagsFor(facility, 'Extra Categories'),
          ];
          return [...new Set(categories.map((category) => category.toLowerCase()))].slice(0, 4);
        };

        return (
          <div className="SearchResult">
            {results.map((facility, index) => (
              
              <div className='facility-card' key={index}>
                  <div className='internal-facility-card'>
                      <div className="card-topline">
                        <span className="result-type">Online resource</span>
                        <span className="source-note">NAMI resource guide</span>
                      </div>
                      <div className='title'><strong>{facility.full_name}</strong></div>

                      <div className="action-row">
                        {(Array.isArray(facility.website) ? facility.website : []).map((item, itemIndex) => (
                            <a key={itemIndex} className="action-button primary-action" href={item} target="_blank" rel="noopener noreferrer">
                              Open resource {facility.website.length > 1 ? itemIndex + 1 : ''}
                            </a>
                        ))}
                        <a className="action-button" href={`mailto:?subject=Search Result for ${facility.full_name}&body=${formatResourcesForEmail(facility)}`} target="_blank" rel="noopener noreferrer">
                          Email
                        </a>
                      </div>
                      
                      <div className='desc'>{facility.desc}</div>

                      {resourceReasonsFor(facility).length > 0 && (
                        <div className="why-match">
                          <div className="why-title">Why this matched</div>
                          <ul>
                            {resourceReasonsFor(facility).map((reason) => (
                              <li key={reason}>{reason}</li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {/* Rendering items_by_category */}
                      <div className='TagsOfInterestBox'>
                        {Object.keys(colorMap).map((categoryKey, catIndex) => (
                          <React.Fragment key={catIndex}> 
                            {resourceTagsFor(facility, categoryKey).map((item, itemIndex) => (
                              <div key={itemIndex} style={{ backgroundColor: colorMap[categoryKey] }} className='TagOfInterest'>{item}</div>
                            ))}
                          </React.Fragment>
                        ))}
                      </div>

                </div>
              </div>
            ))}
            
          </div>
        );
      }


      

      const hasResults = facilitiesSearchResults.length + resourcesSearchResults.length > 0;

      const toggleFacilities = () => {
        if ((showFacilities) && (!showResources)) {
          setShowResources(true);
        }
        setShowFacilities(!showFacilities);
        
      };
    
      const toggleResources = () => {
        if ((showResources) && (!showFacilities)) {
          setShowFacilities(true);
        }
        
        setShowResources(!showResources);
        
      };

      

    
    
// edit the select boxes so that you can click multiple -- cuz right now im only doing one item, so need to force it into an array
return (
    <div className="App">
        <a className="app-brand" href="/" aria-label="SearchMentalHealth home">
          <img src="/favicon.ico" alt="" className="app-brand-icon" />
          <span>SearchMentalHealth</span>
        </a>
        <div className='SearchFormContainer'>
        {/* <div className='MiniContainer'> */}

        <div className="SearchForm">
              <div className="dropdown-container">
                  <div className="dropdown-content">
                    <div className="SearchIntro">
                      <h1 className='AppTitleTwo'>Find mental health services near you</h1>
                      <p>Describe what is going on in your own words. We will match your situation to local facilities and practical resources.</p>
                    </div>

                    <div className="crisis-notice">
                      <strong>In crisis?</strong> Call or text <a href="tel:988">988</a>. If there is immediate danger, call <a href="tel:911">911</a>.
                    </div>

                    <div className="help-container">
                      <textarea
                        id="userInput"
                        value={userInput}
                        onChange={handleUserInputChange}
                        placeholder="Example: I am looking for a therapist for my teenager who has been struggling with depression. We have Medi-Cal and need something near San Francisco..."
                        className="userInput"
                        aria-label="Describe your situation"
                      />
                      {speechSupported && (
                        <div className="voice-controls">
                          <button
                            type="button"
                            className={`voice-button ${isListening ? 'voice-button-active' : ''}`}
                            onClick={handleVoiceInput}
                            aria-pressed={isListening}
                          >
                            {isListening ? <Square size={16} aria-hidden="true" /> : <Mic size={16} aria-hidden="true" />}
                            {isListening ? 'Stop voice' : 'Use voice'}
                          </button>
                        </div>
                      )}
                      {voiceMessage && <p className="voice-status">{voiceMessage}</p>}
                    </div>

                    <div className="prompt-assist-panel">
                      <div className="prompt-assist-header">Optional details</div>
                      <div className="prompt-chip-section" aria-label="Optional search details">
                        {[...promptChips, ...costChips].map((chip) => (
                          <button
                            key={chip.label}
                            type="button"
                            className={`prompt-chip ${userInput.includes(chip.text) ? 'prompt-chip-active' : ''}`}
                            onClick={() => appendToUserInput(chip.text)}
                          >
                            {chip.label}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className='flexBox'>
                      <div className='countyMessage'>State</div>
                      <StateMultiSelect
                          placeholder="CA"
                          onSelect={handleStateSelectionChange}
                      />

                      <div className='countyMessage'>County</div>
                      <div className='addPaddingtoCounty'>
                          <CountyMultiSelect
                              options={countyOptionList}
                              placeholder="Add a county"
                              selectedOptions={countySelection}
                              onSelect={handleCountySelectionChange}
                          />
                      </div>
                    </div>
                    <button className='SearchFormButton' onClick={handleSearchClick} disabled={isLoading}>
                      {isLoading ? (
                        <span className="button-loading">
                          Searching<span className="loading-dots" aria-hidden="true"><span></span><span></span><span></span></span>
                        </span>
                      ) : 'Search'}
                    </button>
                    <div>{showNoInputMessage && (<p className='noInputMessage'>Please describe your situation and select a county.</p>)}</div>
                    {errorMessage && <p className='errorMessage'>{errorMessage}</p>}
                  </div>
              </div>

            </div>
          </div>



        {isLoading ? (
                <div className='loading' role="status" aria-live="polite">
                    <div className="loading-spinner" aria-hidden="true"></div>
                    <div>
                      <div className="loading-title">Finding matches</div>
                      <div className="loading-subtitle">Analyzing your description and local services</div>
                    </div>
                </div>
            ) : (
                <div id='anchor' className="SearchResults">

                {(countySelection.length > 0 && hasGeminiTags) && (
                    <div className='SearchFilterBox'>
           
                        <div className='TagsContainer'>
                            <h3>Refine your AI-determined matching criteria</h3>
                            <div className='addPaddingtoCounty'>
                            <MultiSelect
                                options={generalOptions}
                                placeholder="Add another search filter"
                                selectedOptions={selectedGeminiResults}
                                onSelect={handleGeminiChange} />  
                            </div>
                        </div>   

                        <div className='horizontalLine'></div>

                        <div className='ResultsBox'>
                            <h3>{hasResults ? 'Facilities and resources matched with your situation' : 'No matches yet'}</h3>

                            <div className="toggle-buttons">
                                <p>Show Local Facilities</p>
                                <label className="toggle-switch">
                                
                                  <input type="checkbox" checked={showFacilities} onChange={toggleFacilities} />
                                  <span className="slider">
                                  </span>
                                </label>
                                <p>Show Online Resources</p>
                                <label className="toggle-switch">
                                  
                                  <input type="checkbox" checked={showResources} onChange={toggleResources} />
                                  <span className="slider">
                                  </span>
                                </label>
                              </div>
                            

                                                          {/* {(facilitiesSearchResults.length > 0 && showFacilities) ? (
                                <SearchResult results={facilitiesSearchResults} />
                              ) : (
                                <p>No facilities matched your criteria. Consider adjusting your search prompt or filters, or try searching beyond your county.</p>
                              )} */}
                              
                              {(facilitiesSearchResults.length > 0 && showFacilities) ? (
                                <FacilitiesSearchResult results={facilitiesSearchResults} />
                              ) : ( <p></p>)}
                              {(resourcesSearchResults.length > 0 && showResources) ? (
                                <ResourcesSearchResult results={resourcesSearchResults} />
                              ) : (<p></p> )}

                            {/* {facilitiesSearchResults.length > 0 ? <SearchResult results={facilitiesSearchResults} /> : <p>No search results matched your criteria. Consider adjusting your search prompt or filters, or try searching beyond your county.</p>}
                            {resourcesSearchResults.length > 0 ? <SearchResult results={resourcesSearchResults} /> : <p>No search results matched your criteria. Consider adjusting your search prompt or filters, or try searching beyond your county.</p>} */}

                            {hasResults ? (
                              <p className='bottom-search-message'>Call facilities to confirm services, insurance, availability, and intake requirements before visiting.</p>
                            ) : (
                              <p className='bottom-search-message'>No facilities or resources matched these filters. Try fewer filters, a nearby county, or a broader description.</p>
                            )}
                            
                        </div>
                    </div>
                )}
                </div>
            )}

            <div className='footerMessagesContainer'>
            <TopArrowButton />

          
            <div className='footer-Icons'>
              <a href="https://nami.org/" target="_blank" rel="noreferrer"><img src='/nami-logo-blue.svg' alt="NAMI Logo" className="nami-footer-logo" /></a>
              {/* <a href="https://mentalhealthlab.org/" target="_blank"><img src='mhi_rect.png' alt="NAMI Logo" style={{ width: '195px', height: 'auto', marginLeft: '3vw', padding: '10px 0px' }} /></a> */}
            </div>
              <div className='footerMessages'>
                  <p className='EmergencyWarning'>Please call or text <a href="tel:988">988</a> if you are in a crisis.</p>
                 
                  <p className='DataSources'>Powered by AI, <a href="https://www.namisf.org/resources" target="_blank" rel="noreferrer">NAMI resource guides</a> & <a href="https://www.samhsa.gov/" target="_blank" rel="noreferrer">SAMHSA</a> data |  <a href="https://forms.gle/xmwvhpsbzgp9f7ZW7" target="_blank" rel="noopener noreferrer"><strong>Have feedback or questions?</strong></a> | Created by <a href="https://charlotterosario.vercel.app" target="_blank" rel="noreferrer">CR</a></p>
                  
              </div>

             
            </div>
    </div>
  );

}

export default NewApp;
